import { Loader } from '@googlemaps/js-api-loader';

import { section } from '@/glow';
import { add, remove, qs, qsa } from '@fluorescent/dom';

const selectors = {
  mapContainer: '.map__container',
  map: '.map__element',
  image: '.map__image',
};

const classes = {
  hidden: 'hidden',
};

section('map', {
  onLoad() {
    const map = qs(selectors.mapContainer, this.container);

    if (!map) return;

    const { apiKey, address } = map.dataset;

    const rawData = qs(`#map-styles-${this.id}`, this.container).innerHTML;
    let data;

    if (rawData) {
      try {
        data = JSON.parse(rawData);
      } catch (e) {
        data = {};
        console.error(`Custom map JSON error: ${e}`);
      }
    }

    if (!apiKey || !address) {
      return false;
    }

    // Handle authetication errors
    window.gm_authFailure = function () {
      const maps = qsa(selectors.mapContainer, document);
      const mapImages = qsa(selectors.image, document);

      maps.forEach(map => {
        add(map, classes.hidden);
      });

      mapImages.forEach(img => {
        remove(img, classes.hidden);
      });
    };

    const loader = new Loader({
      apiKey,
      version: 'weekly',
      libraries: ['geocoding-api'],
    });

    loader.load().then(() => {
      add(qs(selectors.image, this.container), classes.hidden);
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ address }, (res, _) => {
        const { location } = res[0].geometry;
        const latLong = { lat: location.lat(), lng: location.lng() };
        const map = new google.maps.Map(qs(selectors.map, this.container), {
          center: latLong,
          zoom: 12,
          styles: data.styles,
        });
        new google.maps.Marker({
          position: latLong,
          map,
        });
      });
    });
  },

  onUnload() {},
});
